import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-60193031"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-wrapper"
};
const _hoisted_2 = {
  class: "course-content"
};
const _hoisted_3 = {
  class: "link-list"
};
const _hoisted_4 = {
  class: "text"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "更多", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu"
}, null, -1));

const _hoisted_7 = {
  class: "course-list"
};
const _hoisted_8 = {
  key: 0,
  class: "no-data",
  style: {
    "margin-bottom": "40px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CardHeader = _resolveComponent("CardHeader");

  const _component_CourseCard = _resolveComponent("CourseCard");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_CardHeader, {
    class: "course-header",
    bodyStyle: {
      background: 'none'
    },
    link: `/courseList.html?type=2&name=${$props.menu.module_name}&menuId=${$props.menu.menu_id}`
  }, {
    left: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString($props.menu.module_name), 1)])]),
    right: _withCtx(() => [_hoisted_5, _hoisted_6]),
    _: 1
  }, 8, ["link"]), _createElementVNode("div", _hoisted_7, [$data.homeCourseList && $data.homeCourseList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.homeCourseList, course => {
    return _openBlock(), _createBlock(_component_CourseCard, {
      info: course,
      key: course.courseId,
      "show-label": true,
      userInfo: $props.userInfo,
      authType: $data.authType
    }, null, 8, ["info", "userInfo", "authType"]);
  }), 128)) : _createCommentVNode("", true)]), $data.homeCourseList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_Empty)])) : _createCommentVNode("", true)])]);
}